import gql from 'graphql-tag';

import { CUSTOMER_PERSONA_FRAGMENT } from 'src/graphql/customerPersona';

export const FRAGMENT_LONG_FORM_VARIABLES = gql`
  fragment LongFormVariables on LongFormVariables {
    info
    title
  }
`;

export const FRAGMENT_CONTEXT_ITEM = gql`
  fragment ContextItem on ContextItem {
    name
    title
    text
    allInstructionsData
  }
`;

export const FRAGMENT_LONG_FORM_BUILDER_PROJECT = gql`
  fragment LongFormBuilderProject on LongFormBuilderProject {
    id
    generationTool
    language
    customerMultiPromptTemplateId
    associatedResources {
      id
      text
      type
    }
    brandVoiceIdsForBrandTerms
    customerPersona {
      ...CustomerPersona
    }
    generationCustomModelId
    wordCount
    tovInput
    blocks {
      blockId
      allInstructionsData
      structureInstructionsData
      generationTool
      name
      order
      language
    }
    promptFields
    contextQuestions {
      ...ContextItem
    }
    variables {
      ...LongFormVariables
    }
  }
  ${FRAGMENT_LONG_FORM_VARIABLES}
  ${FRAGMENT_CONTEXT_ITEM}
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

export const FRAGMENT_PROJECT_LONG_FORM_BUILDER_OUTLINE_SECTION = gql`
  fragment LongFormBuilderOutlineSection on LongFormBuilderOutlineSection {
    id
    projectId
    headline
    status
    content
    paragraphs # can be removed after all sections would be converted to HTML
    order
    keywordsUsage
    manualKeywords
    instructions
    switchState
    lastPlagiarismCheckResult # currently not used for outlines, leaving here for future use
    generationLength
    textStatus
    allInstructionsData
    assetType
    name
    formattingInstructions
  }
`;

export const FRAGMENT_STATS_FACTS_AND_QUOTES_REQUEST = gql`
  fragment StatsFactsAndQuotesFields on StatsFactsAndQuotes {
    text
    type
    resourceType
    name
    url
  }
`;

export const FRAGMENT_LONG_FORM_BUILDER_DRAFT = gql`
  fragment LongFormBuilderDraft on LongFormBuilderDraft {
    id
    projectId
    draftId
    status
    chainId
    name
    generationInfo
  }
`;

export const BLOG_POST_BUILDER_DRAFT = gql`
  fragment BlogPostBuilderDraft on BlogPostBuilderDraft {
    id
    projectId
    draftId
    status
    name
    generationInfo
  }
`;
